// extracted by mini-css-extract-plugin
export default {"screenXLMin":"1279px","footnote":"styles_footnote__vxS+C"};